import { Component, Directive, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseTableClass } from './base_table.class';
import { ActorStatusEnum } from 'src/app/models/api/actor-status-information.model';
import { ActorActionEnum } from 'src/app/constants/actor-action.enum';

@Directive()
export class StatusActionsTableComponent extends BaseTableClass {
  @Input() override tableData: any;
  actionEnum = ActorActionEnum;

  public hasDeclineMessage = (index: any, item: any): Boolean => item.declineMessage != null;

  public isWaiting(actorStatus: string) {
    return actorStatus === ActorStatusEnum.Waiting;
  }
}
@Component({
    selector: 'mobile-status-actions-table',
    templateUrl: './mobile_table_status_actions.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StatusActionsTableMobileComponent extends StatusActionsTableComponent {

}
@Component({
    selector: 'desktop-status-actions-table',
    templateUrl: './desktop_table_status_actions.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StatusActionsTableDesktopComponent extends StatusActionsTableComponent {

}